import * as Phaser from "phaser";
import { strings } from "$/strings";

export class CommonVarsGlobalPlugin extends Phaser.Plugins.BasePlugin {
  // deno-lint-ignore-file no-window no-explicit-any
  public TUNER_TWA_CONFIG = window.tunerTwaConfig;

  public TUNER_REVIVE_CONFIG = window.tunerReviveConfig;

  public TUNER_COINS_STORE_CONFIG = window.tunerCoinsStoreConfig;

  public TWA = window.Telegram.WebApp;

  public WEBVIEW = window.Telegram.WebView;

  public VIEWPORT_HEIGHT = this.TWA?.viewportStableHeight ||
    this.TWA?.viewportHeight;

  public LANG = this.TWA.initDataUnsafe.user.language_code === "ru"
    ? "ru"
    : "en" as "ru" | "en";

  public strings = strings[this.LANG as keyof typeof strings];
}
